export default __webpack_public_path__ + "static/media/desktopinterface.cfa6ab47.png";